import React from 'react';
import { ScrollReveal } from './ScrollReveal';
export function OpportunitySection() {
  return <section className="py-32 px-6 bg-slate text-cream relative overflow-hidden" data-id="element-53">
      {/* Subtle Organic Background — slate tones */}
      <div className="absolute top-0 left-0 w-full h-full overflow-hidden pointer-events-none" data-id="element-54">
        <div className="absolute -top-20 -right-20 w-[40rem] h-[40rem] bg-cream/5 blob-shape-3 blur-3xl opacity-50" data-id="element-55" />
        <div className="absolute bottom-0 left-0 w-[50rem] h-[50rem] bg-cream/3 blob-shape-1 blur-3xl opacity-30" data-id="element-56" />
      </div>

      <div className="max-w-reading mx-auto relative z-10" data-id="element-57">
        <ScrollReveal width="100%" className="mb-16 text-center" data-id="element-58">
          <span className="text-xs font-sans font-medium tracking-editorial text-cream/50 uppercase border-b border-cream/20 pb-2 inline-block" data-id="element-59">
            The Opportunity
          </span>
          <h2 className="font-serif text-4xl md:text-5xl text-cream mt-8 leading-tight" data-id="element-60">
            Embodied Structural Alignment
          </h2>
          <p className="font-serif italic text-xl md:text-2xl text-cream/70 mt-4" data-id="element-61">
            When Your Business Finally Reflects Who You've Become
          </p>
        </ScrollReveal>

        <div className="space-y-10 font-sans text-lg md:text-xl leading-loose font-light text-cream/90" data-id="element-62">
          <ScrollReveal delay={0.2} data-id="element-63">
            <p data-id="element-64">
              There's a different way to grow. One where expansion doesn't cost
              you your peace. Where scaling makes you more stable, not more
              fragmented. Where your business becomes a direct expression of
              your deepest purpose, not a compromise of it.
            </p>
          </ScrollReveal>

          <ScrollReveal delay={0.3} data-id="element-65">
            <p data-id="element-66">
              This happens through Embodied Structural Alignment. First, we
              stabilize your nervous system and recalibrate your leadership
              identity. Then, we redesign your business architecture to match
              who you are now. The result is a foundation strong enough to hold
              the wealth, visibility, and impact you're meant for.
            </p>
          </ScrollReveal>

          <ScrollReveal delay={0.4} data-id="element-67">
            <p data-id="element-68">
              When your internal state and external structure are in sync,
              everything shifts. Decisions become clear. Revenue stabilizes.
              Growth feels natural instead of forced. You stop reacting and
              start leading from a place of deep coherence. This is how you
              build something that can scale to seven figures while giving you
              the freedom to move abroad, become an investor, or simply live a
              life that feels as rich spiritually as it is financially.
            </p>
          </ScrollReveal>
        </div>
      </div>

      <div className="absolute bottom-0 left-0 w-full h-px bg-cream/10" data-id="element-69" />
    </section>;
}